export default "__VITE_ASSET__B$7Y9jLk__"